import React, { useState } from "react";
import LocationSelector from "./location";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card , Button} from "react-bootstrap";


const Map = () => {
    const [selectedLocation, setSelectedLocation] = useState({ lat: 20.5937, lon: 78.9629 });
  const navigate = useNavigate();

  const handleOpenMap = () => {
    navigate("/mapdraw", { state: { selectedLocation } });
  };

  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col md={10}>
          <Card className="shadow-lg p-4">
            <Card.Body>
              <Card.Title className="text-center mb-4">Surveying Application</Card.Title>
              <LocationSelector onLocationSelect={setSelectedLocation} />
              <div className="text-center mt-4">
                <Button variant="primary" onClick={handleOpenMap}>
                  Open Map With Draw
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Map;
